import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './Auth';

import Landing from './Landing';
import Being from './core/Being'; // Updated from Me to Being
import Journey from './core/Journey';
import Vibes from './core/Vibes'; // New Vibes component
import SignIn from './SignIn';
import SignUp from './SignUp';
import EmailConfirmation from './EmailConfirmation';
import Settings from './Settings';
import Navbar from './Navbar';
import Pricing from './Pricing'; // New Pricing component


import Daily from './main/Daily';
import Journal from './main/Journal';
import Astrology from './main/Astrology';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="cosmic-loader"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // if (!user.emailVerified) {
  //   return <Navigate to="/verify-email" replace />;
  // }

  return (
    <>
      <Navbar />
      {children}
    </>
  );
};

const EmailVerificationRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="cosmic-loader"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // If the user is verified, redirect them to the main app
  if (user.emailVerified) {
    return <Navigate to="/calling" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/pricing" element={<Pricing />} />
        
        {/* Protected Routes */}
        {/* <Route 
          path="/verify-email" 
          element={
            <EmailVerificationRoute>
              <EmailConfirmation />
            </EmailVerificationRoute>
          } 
        /> */}
        
        <Route 
          path="/journey" 
          element={
            <ProtectedRoute>
              <Journal />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/being" 
          element={
            <ProtectedRoute>
              <Astrology />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/vibes" 
          element={
            <ProtectedRoute>
              <Daily />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/settings" 
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;